(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name flightWatch.service:FlightWatch
     *
     * @description
     *
     */
    angular
        .module('flightWatch')
        .service('FlightWatch', FlightWatch);

    function FlightWatch(RemoteService,CommonMasterData) {

        var self = this;


        self.searchFlightPairsSchedule = function(param,successFn,errorFn){
            RemoteService.searchFlightSchedule(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.doDailyRotation = function(param,successFn,errorFn){
            RemoteService.doDailyRotation(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.doFullScheduleRotation = function(param,successFn,errorFn){
            RemoteService.doFullScheduleRotation(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.loadAircraftListByCode = function(aircraftModel,successFn,errorFn){
            var paramData = {
                 modelNumber:aircraftModel,
                 isActive : true,
                 pageSize:200,
                 startPosition:0
            };
            RemoteService.loadAircraftList(paramData).then(
                function (response) {
                    successFn(response.aircrafts);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.loadExtraFuelReasons = function(successFn,errorFn) {
            RemoteService.loadExtraFuelReasons().then(
              function (response) {
                successFn(response);
              },
              function (error) {
                errorFn(error.msg);
              }
            );
        };

        self.searchOpenFlightsSchedule = function(param,showPageLoading,successFn,errorFn){
            this.headerParam = {'show-loading': showPageLoading};
            RemoteService.searchOpenFlightSchedule.call(this,param).then(
                function (response) {
                    var openFlights = adaptOpenFlights(response.flightPairs)
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.FlightPairToOpenFlight = function(flightPairs){

        	var flightPairsList = [];
            angular.forEach(flightPairs, function (flightPair) {
				if (flightPair.left !== null && flightPair.left.length > 0) {
					if (flightPair.left[0].aircraftId === null || flightPair.left[0].aircraftId == 0) {
						flightPairsList.push(flightPair);
					}
					return;
				}
            	if(flightPair.right !== null && flightPair.right.length > 0) {
            		if (flightPair.right[0].aircraftId === null || flightPair.right[0].aircraftId == 0) {
						flightPairsList.push(flightPair);
					}
            		return;
            	}
                flightPairsList.push(flightPair);
            });

            adaptOpenFlights(flightPairsList);
            return flightPairsList;

//        	return self.flightWatchOpenFlightPairsAdaptor(flightPair);
        }

        self.getFlightWatchSearchPram = function(searchParam){
            if(searchParam.base === undefined){
                searchParam.base = {'airPortCode':''}
            }
            var req = {
                fromDate: searchParam.fromDate,
                toDate: searchParam.toDate,
                baseAirport: searchParam.base.airPortCode,
                airport: searchParam.selectedAirport.airPortCode,
                aircraftModel:searchParam.aircraftType.modelNumber,
                viewOption:searchParam.viewOption,
                timeZone: searchParam.timeZone
            };
            return req;
            //searchParam.selectedAirport.airPortCode
        };

        self.getDailyRotationSearchPram = function(searchParam){
            var req = {
                fromDate: searchParam.fromDate,
                toDate: searchParam.toDate,
                baseAirport: searchParam.base,
                airport: null,
                aircraftModel:searchParam.modelNumber,
                viewOption:searchParam.viewOption,
                timeZone: searchParam.timeZone
            };
            return req;
        };

        self.setValuesToSearchParam = function(param, acTypes, bases){
        	var model = {
                    fromDate :param.fromDate,
                    toDate : param.toDate,
                    selectedAirport : {airPortCode:''},
                    base:getSelectedBase(param.base, bases),
                    timeZone:param.timeZone,
                    viewOption:param.viewOption,
                    aircraftType: getSelectedAcType(param.modelNumber, acTypes)
                };
        	return model;
        }

        function getSelectedBase(baseAirport, bases){
        	var selectedBase = null;
        	if(!!baseAirport && !!bases){
        		selectedBase = _.find(bases, function(base){
            	    return base.airPortCode === baseAirport;
            	});
        	}
        	return !!selectedBase ? selectedBase : {airPortCode:''};
        }

        function getSelectedAcType(modelNo, acTypes){
        	var selectedAc = null;
        	if(!!modelNo && !!acTypes){
        		selectedAc = _.find(acTypes, function(acType){
            	    return acType.modelNumber === modelNo;
            	});
        	}
        	return !!selectedAc ? selectedAc : {modelNumber:''};
        }

        self.getFullScheduleRotationSearchPram = function(searchParam){
            var req = {
                fromDate: searchParam.fromDate,
                toDate: searchParam.toDate,
                scheduleType: searchParam.scheduleType,
                scheduleYear: searchParam.scheduleYear,
                aircraftModel:searchParam.modelNumber,
                viewOption:searchParam.viewOption,
                timeZone: searchParam.timeZone
            };
            return req;
        };

        self.flightWatchPairsAdaptor = function(data,airCraftTypes){
            var flightPairsList=[];

            angular.forEach(airCraftTypes, function (airCraft) {
                var temp={};
                temp={modelNumber : airCraft.modelNumber,
                registrationID : airCraft.registrationID,
                registrationName : airCraft.registrationName,
                sharket : airCraft.sharket,
                base :airCraft.base,
                pairs : [],//getFlightPairs(airCraft.registrationID,data.flightPairs),
                checks : getFlightChecks(airCraft.registrationID,data.maintenanceCheck),
                acInactivePeriods : airCraft.aircraftInactivePeriods
                };

                flightPairsList.push(temp);
            });
            var mapPairs = getMappedPairs(flightPairsList,data.flightPairs)
            return flightPairsList;

        };

        self.flightWatchOpenFlightPairsAdaptor = function(flightPairs){
            var flightPairsList = [];
            angular.forEach(flightPairs, function (flightPair) {
				if (flightPair.left !== null && flightPair.left.length > 0) {
					if (flightPair.left[0].aircraftId === null) {
						flightPairsList.push(flightPair);
					}
					return;
//					continue;
				}
            	if(flightPair.right !== null && flightPair.right.length > 0) {
            		if (flightPair.right[0].aircraftId === null) {
						flightPairsList.push(flightPair);
					}
            		return;
//            		continue;
            	}
                flightPairsList.push(flightPair);
            });
//            var mapPairs = getMappedPairs(flightPairsList,data.flightPairs)
            adaptOpenFlights(flightPairsList);
            return flightPairsList;

        };


        function getMappedPairs(flightPairsList,flightPairs){


            angular.forEach(flightPairs, function (pair) {
                var temp={};
                if(!!pair.left  && pair.left.length){
                   var leftTemp= _.groupBy(pair.left,'aircraftId');
                    angular.forEach(Object.keys(leftTemp), function (dateKey) {

                            angular.forEach(leftTemp[dateKey], function (piar) {
                                if(temp[dateKey] === undefined){
                                    temp[dateKey]={};
                                    temp[dateKey].left = [];
                                    temp[dateKey].right = [];
                                }
                                temp[dateKey].left.push(piar);
                            });
                    });
                }
                if(!!pair.right && pair.right.length){
                    var rightTemp= _.groupBy(pair.right,'aircraftId');
                    angular.forEach(Object.keys(rightTemp), function (dateKey) {

                        angular.forEach(rightTemp[dateKey], function (piar) {
                            if(temp[dateKey] === undefined){
                                temp[dateKey]={};
                                temp[dateKey].left = [];
                                temp[dateKey].right = [];
                            }
                            temp[dateKey].right.push(piar);
                        });
                    });
                }
                angular.forEach(Object.keys(temp), function (pairKey) {
                    var tempSelection = _.findWhere(flightPairsList, {registrationID: parseInt(pairKey)});
                    if(tempSelection !== undefined){
                        tempSelection.pairs.push(temp[pairKey]);
                    }
                });

            });

        }

        function  getFlightPairs(registrationID,flightPairs){
            var pairs=[];
            angular.forEach(flightPairs, function (pair) {
                if(pair.left.length){
                    if(registrationID === pair.left[0].aircraftId ){
                        pairs.push(pair);
                    }
                }
                else if(pair.right.length){
                    if(registrationID === pair.right[0].aircraftId){
                        pairs.push(pair);
                    }
                }

            });
            return pairs;
        }
        function getFlightChecks(registrationID,checkDetails){
            var checks=[];
            angular.forEach(checkDetails, function(check){

                if(check.aircraftRegId === registrationID){
                	check.edited = false;
                    checks.push(check);

                }

            });
            return checks;

        }
        self.getAirCraftDetails = function(flightLegId,successFn,errorFn){
            var param={
                flightLegId:flightLegId
            };
            RemoteService.getAirCraftDetails(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

      self.checkLogDetails = function (aircraftCheckId, successFn, errorFn) {

        RemoteService.checkLogDetails(aircraftCheckId).then(
          function (response) {
            successFn(response.checkLogDTOs);
          },
          function (error) {
            errorFn(error.msg);
          }
        );
      };

        self.loadUpdateFlightDetails = function(updatedFlightDetails,successFn,errorFn){
            RemoteService.searchFuelInfo(updatedFlightDetails).then(
                function (response) {
                    if(response.success){
                        successFn(response.flightInfoDTO);
                    }
                },
                function (error) {
                    errorFn(error.msg);
                }
            );

        };
        self.mapMovementData = function(airCraftDetails,depDelayList, arrDelaysList,newRemarks,returnFlightData){
            var param = {};
            var depDelays = angular.copy(depDelayList);
            var arrDelays = angular.copy(arrDelaysList)
            param.flightLegId=airCraftDetails.flightLegId;
            param.origin=airCraftDetails.originApt;
            param.destination=airCraftDetails.destinationApt;
            param.bayGate=airCraftDetails.bayGate;
            param.flightLegStatus=airCraftDetails.flightLegStatus;
            param.flightNumber=airCraftDetails.flightNo;
            param.version=airCraftDetails.version;
            param.aircraftModel=airCraftDetails.aircraftModel.modelNumber;

            param.estimatedDepartureDate=airCraftDetails.estimatedDepartureDate;
            param.estimatedDepartureTime=airCraftDetails.estimatedDepartureTime;
            param.estimatedArrivalDate=airCraftDetails.estimatedArrivalDate;
            param.estimatedArrivalTime=airCraftDetails.estimatedArrivalTime;

            param.estimatedLocalDepartureDate=airCraftDetails.estimatedLocalDepartureDate;
            param.estimatedLocalDepartureTime=airCraftDetails.estimatedLocalDepartureTime;
            param.estimatedLocalArrivalDate=airCraftDetails.estimatedLocalArrivalDate;
            param.estimatedLocalArrivalTime=airCraftDetails.estimatedLocalArrivalTime;

            param.actualDepartureDate=airCraftDetails.actualDepartureDate==""?null:airCraftDetails.actualDepartureDate;
            param.actualDepartureTime=airCraftDetails.actualDepartureTime==""?null:airCraftDetails.actualDepartureTime;
            param.actualArrivalDate=airCraftDetails.actualArrivalDate==""?null:airCraftDetails.actualArrivalDate;
            param.actualArrivalTime=airCraftDetails.actualArrivalTime==""?null:airCraftDetails.actualArrivalTime;

            param.takeOffDate=airCraftDetails.takeOffDate==""?null:airCraftDetails.takeOffDate;
            param.takeOffTime=airCraftDetails.takeOffTime==""?null:airCraftDetails.takeOffTime;
            param.landingDate=airCraftDetails.landingDate==""?null:airCraftDetails.landingDate;
            param.landingTime=airCraftDetails.landingTime==""?null:airCraftDetails.landingTime;
            param.regUpdated=airCraftDetails.regUpdated==""?null:airCraftDetails.regUpdated;

            param.legDelays=[];
            angular.forEach(depDelays, function (delay) {
                if(delay.flightDelayReasonCode || delay.delayTime){
                    delay.flightDelayReasonCode = delay.flightDelayReasonCode.delayCode;
                    param.legDelays.push(delay)
                }

            });
            angular.forEach(arrDelays, function (delay) {
                if(delay.flightDelayReasonCode || delay.delayTime){
                    delay.flightDelayReasonCode = delay.flightDelayReasonCode.delayCode;
                    param.legDelays.push(delay)
                }

            });

            param.departureDiversionAirport = (!!airCraftDetails.departureDiversionAptCode && !!airCraftDetails.departureDiversionAptCode.airPortCode) ?  airCraftDetails.departureDiversionAptCode.airPortCode : null;
            param.arrivalDiversionAirport = (!!airCraftDetails.arrivalDiversionAirport && !!airCraftDetails.arrivalDiversionAirport.airPortCode ) ? airCraftDetails.arrivalDiversionAirport.airPortCode : null;

            param.arrivalDiversionActualDepartureDate = airCraftDetails.arrivalDiversionActualDepartureDate || null;
            param.arrivalDiversionActualDepartureTime = airCraftDetails.arrivalDiversionActualDepartureTime || null;

            param.arrivalDiversionTakeOffDate = airCraftDetails.arrivalDiversionTakeOffDate || null;
            param.arrivalDiversionTakeOffTime = airCraftDetails.arrivalDiversionTakeOffTime || null;

            param.arrivalDiversionLandingDate = airCraftDetails.arrivalDiversionLandingDate || null;
            param.arrivalDiversionLandingTime = airCraftDetails.arrivalDiversionLandingTime || null;

            param.arrivalDiversionActualArrivalDate = airCraftDetails.arrivalDiversionActualArrivalDate || null;
            param.arrivalDiversionActualArrivalTime = airCraftDetails.arrivalDiversionActualArrivalTime || null;

            param.etaDate = airCraftDetails.eTADate || null;
            param.etaTime = airCraftDetails.eTATime || null;

            if(airCraftDetails.remarks === null){
              airCraftDetails.remarks=[];
            }
            if(!!newRemarks){
                angular.forEach(newRemarks,function(remark){
                    airCraftDetails.remarks.push(remark);
                });
            }
            param.remarks=airCraftDetails.remarks;
            param.currentAircraftRegistrationId = airCraftDetails.currentRegId ? airCraftDetails.currentRegId.registrationID : null;
            param.etops = airCraftDetails.etops;
            param.hajj = airCraftDetails.hajj;

            if(returnFlightData != null && returnFlightData != undefined && returnFlightData.length > 0){
            	param.returnFlightData = returnFlightData;
            }
            param.operationType = airCraftDetails.operationType.operationTypeCode;
            return param;
        }

        self.getreturnFlightLegDetails = function(selectedFlightLeg,rotationData){

        	var returnFlightData = null;

        	angular.forEach(rotationData, function (aircraftRotation) {
        		angular.forEach(aircraftRotation.pairs, function (flightPair) {
        			angular.forEach(flightPair.left, function (leftSectionFlightLeg) {
        				if(leftSectionFlightLeg.flightLegId === selectedFlightLeg ){
            				 returnFlightData = flightPair.right;
            				 return;
            			}
        			});
        		});

            });

        	var returnFlightLegArray = [];
        	angular.forEach(returnFlightData, function (returnFlight) {
        		returnFlightLegArray.push(returnFlight.flightLegId);
        	});
        	return returnFlightLegArray;
        }

        self.updatePassengerDetails = function(updatePassengerDetails,successFn,errorFn){
            RemoteService.updateFlightPassengerDetails(updatePassengerDetails).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );

        };
        self.cancelOrReInstateFlight= function(flightLegID,successFn,errorFn){
            RemoteService.cancelOrReInstateFlight(flightLegID).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.updateFlightInfo = function(date,successFn,errorFn){
        	RemoteService.updateFlightInfo(date).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg);
                    }
                );
        };

        self.updateAdHocAtcCallSign = function(data,successFn,errorFn){
          RemoteService.updateAdHocAtcCallSign(data).then(
            function (response) {
              successFn(response);
            },
            function (error) {
              errorFn(error.msg);
            }
          );
        };

        self.mapFuelData = function(airCraftDetails){
            var param = {};

            param.flightLegId=airCraftDetails.flightLegId;
            param.version = airCraftDetails.version;

            param.flightLegRelatedFuelInfo={};
            param.fuelUpliftRelatedInfo={};

            param.flightLegRelatedFuelInfo.pld= parseFloat(airCraftDetails.pld);
            param.flightLegRelatedFuelInfo.sg= parseFloat(airCraftDetails.sg);
            param.flightLegRelatedFuelInfo.minFuel=parseFloat(airCraftDetails.minFuel);
            param.flightLegRelatedFuelInfo.fuelUpLftDep=parseFloat(airCraftDetails.fuelUpLftDep);
            param.flightLegRelatedFuelInfo.fuelOBDep=parseFloat(airCraftDetails.fuelOBDep);
            //param.remainngFuel='';
            param.flightLegRelatedFuelInfo.etopsFlag=airCraftDetails.etops;
            param.flightLegRelatedFuelInfo.includeInEtsFlag=airCraftDetails.includeEts;
            param.flightLegRelatedFuelInfo.zeroFuelWeight=null;
            param.flightLegRelatedFuelInfo.remainingFuel=parseFloat(airCraftDetails.remainingFuel);

            param.fuelUpliftRelatedInfo.density=parseFloat(airCraftDetails.sg); //airCraftDetails.sg;
            param.fuelUpliftRelatedInfo.fuelUplift=parseFloat(airCraftDetails.fuelUpLftDep);
            param.fuelUpliftRelatedInfo.receiptNo=airCraftDetails.fuelInvoiceNo;
            param.fuelUpliftRelatedInfo.ebsNo=airCraftDetails.ebsNo;
            param.fuelUpliftRelatedInfo.defueling=parseFloat(airCraftDetails.defueling);
            param.fuelUpliftRelatedInfo.leakages=parseFloat(airCraftDetails.leakages);
            param.fuelUpliftRelatedInfo.fuelSupplierId=airCraftDetails.fuelSupplierTemp.fuelSupplierId;
            param.fuelUpliftRelatedInfo.airportCode=airCraftDetails.originApt;
            param.fuelUpliftRelatedInfo.fuelUpliftId=airCraftDetails.fuelSupplierTemp.fuelSupplierId;
            param.fuelUpliftRelatedInfo.fuelUpliftVersion=null;
            param.fuelUpliftRelatedInfo.createdBy=null;
            param.fuelUpliftRelatedInfo.createdDate=null;
            param.fuelUpliftRelatedInfo.modifiedBy=null;
            param.fuelUpliftRelatedInfo.modifiedDate=null;

            param.flightLegRelatedFuelInfo.approachType=airCraftDetails.approachTypeTemp.approachConCode;
            param.flightLegRelatedFuelInfo.approachCondition=airCraftDetails.approachConditionTemp.approachTypeCode;

            //param.flightLegRelatedFuelInfo.requestExtraFuel = airCraftDetails.requestExtraFuel;
            param.flightLegRelatedFuelInfo.extraFuel = airCraftDetails.extraFuel;
            if (airCraftDetails.remarksOnExtraFuel != "Other") {
              param.flightLegRelatedFuelInfo.remarksOnExtraFuel = airCraftDetails.remarksOnExtraFuel;
              param.flightLegRelatedFuelInfo.reasonTypeExFuelPreDefined = "Y";
            }
            else {
              param.flightLegRelatedFuelInfo.remarksOnExtraFuel = airCraftDetails.otherReasonOnExtraFuelUplift;
              param.flightLegRelatedFuelInfo.reasonTypeExFuelPreDefined = "N";
            }
            param.flightLegRelatedFuelInfo.extraFuelRequestBy = "Dispatcher";
            param.flightLegRelatedFuelInfo.requestedByDispatch = true;

          return param;

        };

        self.updatedFlightDetails = function (dataModel, updateDetails) {
            var params = dataModel;
            params.pld = updateDetails.pld;
            params.fuelOBDep = updateDetails.fuelOBDep;
            params.fuelUpLftDep = updateDetails.fuelUpLft;
            params.sg = updateDetails.sg;
            params.minFuel = updateDetails.minFuel;
            params.approachType = updateDetails.approachType;
            params.approachCondition = updateDetails.approachCondition;
            params.zeroFuelWeight = updateDetails.zeroFuelWeight;
            params.remainingFuel = updateDetails.remainingFuel;
            params.etops = updateDetails.etopsFlag;
            params.includeEts = updateDetails.includeInEtsFlag;
            params.defueling = updateDetails.defueling;
            params.leakages = updateDetails.leakages;
            params.ebsNo = updateDetails.ebsNo;
            params.fuelSupplierId = updateDetails.fuelSupplierId;
            params.fuelInvoiceNo = updateDetails.receiptNo;
            params.createdBy = updateDetails.createdBy;
            params.createdDate = updateDetails.createdDate;
            params.fuelUpliftVersion = updateDetails.fuelUpliftVersion;
            params.fuelUpliftId = updateDetails.fuelUpliftId;
            if (!updateDetails.extraFuel) {
              params.requestExtraFuel = false;
            }
            else {
              params.requestExtraFuel = true;
            }
            params.extraFuel = updateDetails.extraFuel;

            if (updateDetails.reasonTypeExFuelPreDefined == "Y") {
              params.remarksOnExtraFuel = updateDetails.remarksOnExtraFuel;
            }
            else if (updateDetails.reasonTypeExFuelPreDefined == "N") {
              params.remarksOnExtraFuel = "Other";
              params.otherReasonOnExtraFuelUplift = updateDetails.remarksOnExtraFuel;
            }

            if (updateDetails.extraFuelRequestBy != null && updateDetails.extraFuelRequestBy != "Dispatcher") {
              params.avoidRequestExtraFuel = true;
            }
            params.requestedByDispatch = updateDetails.requestedByDispatch;
            return params;
        };
        self.updateFlightDetails = function(updateDetails,successFn,errorFn){
            RemoteService.updateFlightDetails(updateDetails).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );

        };

        self.updateFuelDetails = function(fuelDetails,successFn,errorFn){
            RemoteService.updateFuelDetails(fuelDetails).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };
        self.loadFlightAssignedCrew =function(flightLegID,successFn,errorFn){
            RemoteService.loadFlightAssignedCrew(flightLegID).then(
                function (response) {
                    successFn(response.flightAssignedCrew);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };
        self.updateTakeOffLandingDetails=function(airCraftDetails,takeOffLandingInfo,successFn,errorFn){
            var param = {};

            param.flightLegId=airCraftDetails.flightLegId;
            param.version = airCraftDetails.version;
            param.takeOffCrewProfileId= takeOffLandingInfo.takeOffCrewProfileId ;
            param.landingCrewProfileId= takeOffLandingInfo.landingCrewProfileId ;

            RemoteService.updateTakeOffLanding(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.populateUpdateTakeOffLandingDetails=function(airCraftDetails,takeOffLandingInfo){
            var param = {};

            param.flightLegId=airCraftDetails.flightLegId;
            param.version = airCraftDetails.version;
            param.takeOffCrewProfileId= takeOffLandingInfo.takeOffCrewProfileId ;
            param.landingCrewProfileId= takeOffLandingInfo.landingCrewProfileId ;

           return param;
        };



        self.getFuelSuppliers = function(params, successFn, errorFn) {
            RemoteService.searchFuelSuppliers(params).then(
                function (response) {
                    if(response.success && !!response.fuelSupplierInfoCollection){
                        successFn(self.getFormattedFuelSuppliers(response.fuelSupplierInfoCollection));
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.getFuelSuppliersForFuelUplift = function(params, successFn, errorFn) {
          RemoteService.searchFuelSuppliersForFuelUplift(params).then(
            function (response) {
              if(response.success && !!response.fuelSupplierInfoCollection){
                successFn(self.getFormattedFuelSuppliers(response.fuelSupplierInfoCollection));
              }
            },
            function (error) {
              errorFn(error);
            }
          );
        };

        self.getFormattedFuelSuppliers = function (suppliers) {
            var suppliersArray = [];
            _.each(suppliers, function (suplier) {
                var newSupplier = {};
                newSupplier.fuelSupplierId = suplier.fuelSupplierId;
                newSupplier.title = suplier.companyName + " (" + suplier.companyAbbr + ")";
                suppliersArray.push(newSupplier);
            });
            return suppliersArray;
        };

        self.saveRotation = function (rotationDetails,successFn,errorFn){
            RemoteService.saveRotationDetails(rotationDetails).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg);
                }
            );
        };

        self.loadFuelInfoForFlightLeg = function (params, successFu, errorFn) {
            var params = {
                flightLegId:params.flightLegId
            }
            RemoteService.searchFuelInfo(params).then(
                function (response) {
                    successFu(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.sendRotationChangeEmail = function (request,successFu, errorFn){
        	RemoteService.sendRotationChangeEmail(request).then(
        		function (response) {
                    successFu(response);
                },
                function (error) {
                    errorFn(error);
                }
        	);
        };

        self.sendRotationEmail = function (request,successFu, errorFn){
        	RemoteService.sendRotationEmail(request).then(
            		function (response) {
                        successFu(response);
                    },
                    function (error) {
                        errorFn(error);
                    }
            	);
        };

        self.searchRotationSummary = function (request, successFn, errorFn){
        	RemoteService.getRotationSummary(request).then(
            		function (response) {
                        successFn(response.rotationSummaryDTOs);
                    },
                    function (error) {
                        errorFn(error);
                    }
            	);
        };

      self.loadLatestSlotMessageByFlightLegId = function (flightLegId, callback) {
        RemoteService.loadSlotMessageByFlightLeg(flightLegId, true).then(function (response) {

          if(response.success){
            if(response.slotProcessedMessageDTOS.length > 0){

              var slotMessage = response.slotProcessedMessageDTOS[0];
              callback(slotMessage);
            }

          }else{
           alert('error');
          }
        })

      }



      function updateMinMax(yCol, index, start, end) {
            if (angular.isUndefined(yCol[index])) {
                yCol[index] = {};
            }

            if (angular.isUndefined(yCol[index].minDate) || start < yCol[index].minDate) {
                yCol[index].minDate = start;
            }

            if (angular.isUndefined(yCol[index].maxDate) || end > yCol[index].maxDate) {
                yCol[index].maxDate = end;
            }
        }

        function getRowIndex(rowMinMax, start, end) {
            var obj;
            var rowIndex = -1;
            for (var i = 0; i < rowMinMax.length; i++) {
                obj = rowMinMax[i];
                if (
                    (end.isSameOrBefore(rowMinMax[i].minDate, 'minute')) || (start.isSameOrAfter(rowMinMax[i].maxDate, 'minute'))
                    ) {
                    updateMinMax(rowMinMax, i, start, end);
                    rowIndex = i;
                    break;
                }
            }

            if (rowIndex == -1) {
                rowIndex = rowMinMax.length;
                updateMinMax(rowMinMax, rowIndex, start, end);
            }
            return rowIndex;
        }

        function adaptOpenFlights(flightPairs){


            angular.forEach(flightPairs, function (pair) {
                if(!!pair.left){
                    pair.pairStartDate=pair.left[0].estDeptDate;
                    pair.pairStartTime=pair.left[0].estDeptTime;
                    pair.modelNo = pair.left[0].modelNo;
                    pair.pairStart=pair.left[0].estDeptDate+' '+pair.left[0].estDeptTime;
                    if(!!pair.right){
                        pair.pairEndDate=pair.right[pair.right.length-1].estArvlDate;
                        pair.pairEndTime=pair.right[pair.right.length-1].estArvlTime;
                        pair.pairEnd=pair.right[pair.right.length-1].estArvlDate+' '+pair.right[pair.right.length-1].estArvlTime;
                    }
                    else{
                        pair.pairEndDate=pair.left[pair.left.length-1].estArvlDate;
                        pair.pairEndTime=pair.left[pair.left.length-1].estArvlTime;
                        pair.pairEnd=pair.left[pair.left.length-1].estArvlDate+' '+pair.left[pair.left.length-1].estArvlTime;
                    }
                }
                else{
                    pair.pairStartDate=pair.right[0].estDeptDate;
                    pair.pairStartTime=pair.right[0].estDeptTime;
                    pair.modelNo = pair.right[0].modelNo;
                    pair.pairStart=pair.right[0].estDeptDate+' '+pair.right[0].estDeptTime;
                    pair.pairEndDate=pair.right[pair.right.length-1].estArvlDate;
                    pair.pairEndTime=pair.right[pair.right.length-1].estArvlTime;
                    pair.pairEnd=pair.right[pair.right.length-1].estArvlDate+' '+pair.right[pair.right.length-1].estArvlTime;
                }
            });

            flightPairs = _.groupBy(flightPairs,'pairStartDate');
            flightPairs = avoidPairsOverlap(flightPairs);
            return flightPairs;
        }
        function avoidPairsOverlap(flightPairs){
            var rowMinMax = [];
            var tmpMomentStart;
            var tmpMomentEnd;

            angular.forEach(Object.keys(flightPairs), function (dateKey) {
                angular.forEach(flightPairs[dateKey], function (pattern) {
                    tmpMomentStart = moment(pattern.pairStart, 'DD/MM/YYYY HH:mm');
                    tmpMomentEnd = moment(pattern.pairEnd, 'DD/MM/YYYY HH:mm');
                    pattern.rowIndex = getRowIndex(rowMinMax, tmpMomentStart, tmpMomentEnd);
                });
            });
            return flightPairs;
        }

      self.searchSlotMessageSummary = function (request, successFn, errorFn){
        RemoteService.searchSlotMessageSummary(request).then(
          function (response) {
            successFn(response.slotProcessedMessageDTOS);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.sendFlightCrewNotifications = function (request, successFn, errorFn){
        RemoteService.sendFlightCrewNotifications(request).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.loadDefaultMessagesByFlightLeg = function(request,successFn,errorFn){
        RemoteService.loadDefaultMessagesByFlightLeg(request).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.checkSavePriviledge = function (successFn, errorFn) {
        RemoteService.checkFlightWatchSavePriviledge().then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.checkAircraftRegistrationUpdateStatus = function (request, successFn, errorFn){
        RemoteService.checkAircraftRegistrationUpdateStatus(request).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.amadeusAircraftRegistrationSubmit = function (request, successFn, errorFn){
        RemoteService.amadeusAircraftRegistrationSubmit(request).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

    }
}());
